var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiteraM(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Litera_M",
    "data-name": "Litera M",
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 125,
    height: 125,
    rx: 62.5,
    fill: "#ff91ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30367_",
    transform: "translate(29.36 16.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2901_",
    transform: "translate(9.95 20.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2923_",
    d: "M191.456,134.92l-9.4,33.666.6.34,20.44-11.468Z",
    transform: "translate(-161.416 -109.944)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2974_",
    d: "M167.91,126.68l.642,38.291.511.3,15.348-9.118L181.6,118.02Z",
    transform: "translate(-167.91 -118.02)",
    fill: "#0c1859"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2967_",
    transform: "translate(15.844 9.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2482_",
    d: "M187.173,110.67l7.718,35.158-13.043,15.99-9.5-42.341Z",
    transform: "translate(-171.766 -110.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2971_",
    d: "M181.754,163.124l-9.8-43.73,15.261-9.074.584.192,7.82,35.631ZM173.117,119.9l9.177,40.952,12.226-14.971-7.514-34.213Z",
    transform: "translate(-171.95 -110.32)",
    fill: "#0c1859"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2902_",
    d: "M180.732,173.429l-9.06-42.622-.277-.163c.423,6.606.642,11.66.642,15.192v22.508l-10.607-6.207V110.31l15.946,9.325,9.25,42.193.248.148,9.06-31.493,15.976,9.34v51.829l-11-6.429V162.508q0-1.773.044-3.9t.408-10.36l-.277-.163-8.943,32.025Z",
    transform: "translate(-160.934 -100.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2990_",
    d: "M161.43,113.163l14.808-8.793,15.946,9.311-14.823,8.808Z",
    transform: "translate(-160.934 -103.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2986_",
    d: "M185.07,126.818l14.808-8.808,15.976,9.34-14.823,8.808Z",
    transform: "translate(-150.084 -97.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_",
    transform: "translate(0.496 4.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M161.43,116.1l14.808-8.793,15.946,9.325-14.823,8.793Z",
    transform: "translate(-161.43 -107.31)",
    fill: "#ff91ab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2965_",
    d: "M185.07,129.753l14.808-8.793,15.976,9.34-14.823,8.793Z",
    transform: "translate(-150.084 -95.836)",
    fill: "#ff91ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2968_",
    d: "M210.884,124.133l-15.246,9.059-8.681,30.163-8.856-40.42,14.619-8.675.073-.709-16.384-9.591-15.319,9.1v52.42l11.117,6.5.511-.3v-22.8c0-2.527-.117-5.882-.336-10.005l8.068,37.937,11.847,6.916.438-.236,8.126-29.129c-.161,3.68-.248,6.118-.277,7.271-.029,1.434-.044,2.734-.044,3.916v23.025l11.511,6.739,15.319-9.1V133.8Zm-34.49-18.976,14.925,8.719-13.8,8.2-14.925-8.719Zm35.132,88.627-9.979-5.838V165.528q0-1.773.044-3.9c.029-1.448.16-4.921.408-10.345l.015-.31-1.109-.65-8.943,32.025-10.636-6.222-9.06-42.622-1.3-.768.058.975c.423,6.562.627,11.66.627,15.148v21.606l-9.585-5.6V114.231l14.984,8.764,9.25,42.193,1.007.591,9.06-31.493,15.144,8.867v50.632Zm-14.444-60.267,13.8-8.2,14.954,8.749-13.8,8.2Z",
    transform: "translate(-161.09 -103.96)",
    fill: "#0c1859"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2406_",
    transform: "translate(33.076 24.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2405_",
    d: "M172.978,117.927c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.5,1.5,0,0,1,172.978,117.927Z",
    transform: "translate(-160.136 -104.726)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2404_",
    d: "M175.528,116.457c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.5,1.5,0,0,1,175.528,116.457Z",
    transform: "translate(-158.965 -105.429)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2403_",
    d: "M178.068,114.987c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.5,1.5,0,0,1,178.068,114.987Z",
    transform: "translate(-157.8 -106.131)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2402_",
    d: "M180.618,113.514c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0,.438.438,0,0,1,0-.828,1.589,1.589,0,0,1,1.415,0Z",
    transform: "translate(-156.629 -106.83)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2401_",
    cx: 1.007,
    cy: 0.591,
    rx: 1.007,
    ry: 0.591,
    transform: "translate(7.415 10.851)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2400_",
    d: "M172.978,114.987c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.5,1.5,0,0,1,172.978,114.987Z",
    transform: "translate(-160.136 -106.131)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2399_",
    d: "M175.528,113.514c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0,.438.438,0,0,1,0-.828A1.589,1.589,0,0,1,175.528,113.514Z",
    transform: "translate(-158.965 -106.83)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2398_",
    d: "M178.068,112.044c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828a1.589,1.589,0,0,1,1.415,0Z",
    transform: "translate(-157.8 -107.533)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2397_",
    d: "M167.888,114.987c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.5,1.5,0,0,1,167.888,114.987Z",
    transform: "translate(-162.472 -106.131)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2392_",
    d: "M170.438,113.514c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0,.437.437,0,0,1,0-.828A1.589,1.589,0,0,1,170.438,113.514Z",
    transform: "translate(-161.301 -106.83)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2391_",
    d: "M172.978,112.044c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.589,1.589,0,0,1,172.978,112.044Z",
    transform: "translate(-160.136 -107.533)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2390_",
    d: "M175.528,110.574c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828a1.589,1.589,0,0,1,1.415,0Z",
    transform: "translate(-158.965 -108.235)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2389_",
    d: "M165.348,113.514c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0,.437.437,0,0,1,0-.828A1.589,1.589,0,0,1,165.348,113.514Z",
    transform: "translate(-163.637 -106.83)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2388_",
    d: "M167.888,112.044c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.589,1.589,0,0,1,167.888,112.044Z",
    transform: "translate(-162.472 -107.533)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2387_",
    cx: 1.007,
    cy: 0.591,
    rx: 1.007,
    ry: 0.591,
    transform: "translate(7.415 2.161)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2386_",
    d: "M172.978,109.1c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828a1.589,1.589,0,0,1,1.415,0Z",
    transform: "translate(-160.136 -108.938)",
    fill: "#0c1859"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2408_",
    transform: "translate(67.595 43.909)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2424_",
    cx: 1.007,
    cy: 0.591,
    rx: 1.007,
    ry: 0.591,
    transform: "translate(11.135 13.02)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2423_",
    d: "M199.188,129.807c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.5,1.5,0,0,1,199.188,129.807Z",
    transform: "translate(-182.625 -118.782)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2422_",
    d: "M201.728,128.334c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.589,1.589,0,0,1,201.728,128.334Z",
    transform: "translate(-181.46 -119.481)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2421_",
    d: "M204.278,126.864c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828a1.589,1.589,0,0,1,1.415,0Z",
    transform: "translate(-180.289 -120.184)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2420_",
    d: "M194.1,129.807c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.5,1.5,0,0,1,194.1,129.807Z",
    transform: "translate(-184.961 -118.782)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2419_",
    d: "M196.638,128.334c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.589,1.589,0,0,1,196.638,128.334Z",
    transform: "translate(-183.796 -119.481)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2418_",
    d: "M199.188,126.864c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.589,1.589,0,0,1,199.188,126.864Z",
    transform: "translate(-182.625 -120.184)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2417_",
    d: "M201.728,125.394a.438.438,0,0,1,0,.828,1.5,1.5,0,0,1-1.415,0,.438.438,0,0,1,0-.828,1.589,1.589,0,0,1,1.415,0Z",
    transform: "translate(-181.46 -120.886)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2416_",
    cx: 1.007,
    cy: 0.591,
    rx: 1.007,
    ry: 0.591,
    transform: "translate(3.709 8.675)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2415_",
    d: "M194.1,126.864c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.589,1.589,0,0,1,194.1,126.864Z",
    transform: "translate(-184.961 -120.184)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2414_",
    d: "M196.638,125.394c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0,.438.438,0,0,1,0-.828A1.589,1.589,0,0,1,196.638,125.394Z",
    transform: "translate(-183.796 -120.886)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2413_",
    d: "M199.188,123.924c.394.236.394.606,0,.828a1.589,1.589,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828a1.589,1.589,0,0,1,1.415,0Z",
    transform: "translate(-182.625 -121.589)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2412_",
    d: "M189.008,126.864c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.589,1.589,0,0,1,189.008,126.864Z",
    transform: "translate(-187.298 -120.184)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2411_",
    cx: 1.007,
    cy: 0.591,
    rx: 1.007,
    ry: 0.591,
    transform: "translate(3.709 4.33)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2410_",
    d: "M194.1,123.924c.394.236.394.606,0,.828a1.589,1.589,0,0,1-1.415,0c-.394-.236-.394-.606,0-.828A1.589,1.589,0,0,1,194.1,123.924Z",
    transform: "translate(-184.961 -121.589)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2409_",
    d: "M196.638,122.467c.394.236.394.606,0,.828a1.5,1.5,0,0,1-1.415,0,.438.438,0,0,1,0-.828,1.5,1.5,0,0,1,1.415,0Z",
    transform: "translate(-183.796 -122.29)",
    fill: "#0c1859"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteraM);
export default __webpack_public_path__ + "static/media/Litera M.0841f907a73e61f086725b54eb429336.svg";
export { ForwardRef as ReactComponent };